import { render, staticRenderFns } from "./CreateCommunityCTA.vue?vue&type=template&id=6e404b5a&scoped=true&"
import script from "./CreateCommunityCTA.vue?vue&type=script&lang=js&"
export * from "./CreateCommunityCTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e404b5a",
  null
  
)

export default component.exports